import {EventBus} from '@/event-bus.js';
import {getField, updateField} from 'vuex-map-fields';
import DEFINES from '@/defines';
import router from '@/router';
import * as API from '@/api';

function initialState () {
  return {
    list: [],
    selection_list: [],
    film: null,
    uploading_link: null,
  };
}

const state = initialState ();

// actions

const actions = {
  async create (context, payload) {
    var response = await API.film.create (payload);
    context.commit ('set_film', {
      film: response.film,
    });
    return response;
  },

  async get (context, payload) {
    var response = await API.film.get (payload);
    return response.film;
  },

  async delete (context, payload) {
    var response = await API.film.delete (payload);
    return response;
  },

  async list (context, payload) {
    var response = await API.film.list (payload);

    await context.commit ('set_list', {
      films: response.films,
    });
    return response;
  },

  async update (context, payload) {
    var response = await API.film.update (payload);
    //Update list when any film is updated
    context.dispatch ('list');
    return response;
  },

  async embed (context, payload) {
    var response = await API.film.embed (payload);
    return response;
  },

  async onAfterCreate (context) {
    context.dispatch (
      'app/showMessage',
      {
        message: 'Film created successfully',
        color: DEFINES.SNACKBAR_SUCCESS_COLOR,
      },
      DEFINES.USE_ROOT
    );

    router.push ({
      name: 'FilmsDashboard',
      params: {
        company_id: context.rootGetters['company/getSelected'],
      },
    });
  },

  async setEditableFilm (context, payload) {
    //get film from list
    var film = context.getters['getFilm'] (payload.id);
    //if film is not found in list get film from backend
    if (film == undefined) {
      film = await context.dispatch ('get', payload);
    }
    context.commit ('set_film', {
      film: Object.assign ({}, film),
    });
    return film;
  },
  async resetEditableFilm (context) {
    context.commit ('reset_editable_film');
  },
  // async getFilmFromImdb(context, payload) {
  //   var response = await API.film.importFromImdb(payload);
  //   return response.film;
  // },

  // async createFilmFromImdb(context, payload) {
  //   var response = await API.film.createFilmFromImdb(payload);
  //   return response;
  // },

  async requestRightHolderForMedia (context, payload) {
    var response = await API.film.requestRightHolderForMedia (payload);
    return response;
  },

  async gDriveUpload (context, payload) {
    var response = await API.film.gDriveUpload (payload);
    return response;
  },

  async getSelectionList (context, payload){
    var response = await API.film.getSelectionList (payload);

    await context.commit ('set_selection_list', {
      films: response.films,
    });
    return response;
  },

  async import(context, payload){
    var response = await API.film.import(payload);
    return response;
  },

  async getStreamingUrl (context, payload){
    var response = await API.film.getStreamingUrl (payload);
    return response;
  },
};

// getters
const getters = {
  getField,
  getFilm: state => id => {
    var film = state.list.find (film => {
      return film.id == id;
    });
    return film;
  },

  getMediasFromId: (
    state,
    getters,
    rootState,
    rootGetters
  ) => collection_type => {
    var media = [];
    if (!state.film) {
      return media;
    }
    //return all the medias using screeners, trailers etc. ids
    state.film[collection_type].forEach (media_id => {
      var file = rootGetters['files/getMediaFiles'] ('film', media_id);
      if (file != undefined) {
        media.push (file);
      }
    });
    return media;
  },


  getDeliverablesFromId: (state, getters, rootState, rootGetters) => ids => {
    var media = [];
    //return all the medias using screeners, trailers etc. ids
    ids.forEach (media_id => {
      var file = rootGetters['files/getMediaFiles'] ('film', media_id);
      media.push (file);
    });
    return media;
  },
};

// mutations
const mutations = {
  updateField,
  set_list (state, payload) {
    state.list = payload.films.data;
  },

  set_selection_list(state, payload){
    state.selection_list = payload.films;
  },

  set_film (state, payload) {
    state.film = payload.film;
  },

  update_film (state, payload) {
    state.list = [
      ...state.list.filter (film => film.id !== payload.film.id),
      payload.film,
    ];
  },
  reset_editable_film (state) {
    state.film = null;
  },
  reset (state) {
    // acquire initial state
    const s = initialState ();
    Object.keys (s).forEach (key => {
      state[key] = s[key];
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
